import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-membersidebar',
  templateUrl: './membersidebar.component.html',
  styleUrls: ['./membersidebar.component.scss']
})
export class MembersidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
